<div
  class="event-card tw-font-inter tw-bg-white dark:tw-bg-gray-800 tw-rounded-xl tw-shadow-lg tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-overflow-hidden tw-cursor-pointer"
  (click)="eventSelected.next(event())"
>
  <!-- Cover Image Section -->
  <div class="tw-relative tw-h-32">
    <div class="tw-absolute tw-inset-0 tw-bg-cover tw-bg-center tw-bg-no-repeat" [ngStyle]="{ 'background-image': getCoverPhoto }"></div>
  </div>

  <!-- Content Section -->
  <div class="tw-p-4 md:tw-p-5">
    <!-- Header with Title and Status -->
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <h5
        class="event-title tw-font-bold tw-text-gray-900 dark:tw-text-white tw-text-base md:tw-text-lg tw-leading-tight tw-font-inter tw-flex-1 tw-min-w-0"
        [title]="event()?.name"
      >
        {{ event()?.name }}
      </h5>

      <!-- Event Status - only show for Live and Upcoming -->
      @if (eventStatusRaw === 'Live' || eventStatusRaw === 'Upcoming') {
      <span
        class="pill tw-px-2 tw-py-1 tw-font-inter tw-font-bold tw-text-xs tw-rounded-full tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tw-flex-shrink-0"
        [ngClass]="{
          live: eventStatusRaw === 'Live',
          upcoming: eventStatusRaw === 'Upcoming'
        }"
      >
        <span class="tw-w-2 tw-h-2 tw-rounded-full"> </span>
        {{ eventStatus }}
      </span>
      }
    </div>

    <!-- Event Status/Info -->
    @if (event()?.status) {
    <div class="tw-mt-4 tw-pt-4 tw-border-t tw-border-gray-100">
      <div class="tw-flex tw-items-center tw-justify-between">
        <span class="tw-text-sm tw-text-gray-500 tw-font-inter tw-font-medium"> Status </span>
        <span class="tw-text-sm tw-font-medium tw-text-gray-900 tw-capitalize tw-font-inter">
          {{ event()?.status }}
        </span>
      </div>
    </div>
    }
  </div>
</div>
